<template>
    <transition name="fade-slide">
        <div class="brt-footprint-drawer" v-if="visible">
            <div class="brt-footprint fade-slide-bottom">
                <div class="close" @click="close">
                    <i class="iconfont icon-close-02"></i>
                </div>

                <div class="brt-foot-head">
                    <span :class="{active: tabIndex === 1}" @click="tabIndex = 1">
                        <i class="iconfont icon-collection-o"></i>
                        收藏夹
                    </span>
                    <span :class="{active: tabIndex === 2}" @click="tabIndex = 2">
                        <i class="iconfont icon-footprint-o"></i>
                        历史足迹
                    </span>
                </div>

                <div class="brt-foot-body" :tab-index="tabIndex">
                    <div class="brt-foot-scroll">
                        <ul class="collection-ul">
                            <li v-for="(item, index) in Array.prototype.reverse.call(collectionArray)"
                                @click=" editState == 0 ? select(JSON.parse(item.poi)) : ''">
                                <div class="icon">
                                    <img class="img" src="../../../public/images/poi-class-01.png" v-if="item.LEVEL">
                                    <i class="iconfont icon-marker" v-else></i>
                                </div>
                                <div class="content">
                                    <div>{{ JSON.parse(item.poi).NAME }}</div>
                                    <div class="t2" v-if="JSON.parse(item.poi).CATEGORY_NAME">
                                        {{ JSON.parse(item.poi).CATEGORY_NAME }}
                                        <i></i>
                                        {{ JSON.parse(item.poi).FLOOR_NAME }}
                                    </div>
                                </div>

                                <div class="right" v-if="!item.LEVEL">
                                    <span class="btn" v-if="!collectionEditState">
                                        <i class="iconfont icon-go-to"></i>
                                        <span>{{$BRT.$route.selectType.pointType == 'start' ? '从这去':'到这去'}}</span>
                                    </span>
                                    <span class="remove" @click="deleteD(item)"  v-else>
                                        删除
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="brt-foot-scroll">
                        <ul class="footprint-ul">
                            <li v-for="(item,index) in Array.prototype.reverse.call(historyArray)" @click="editState == 0 ? select(item) : ''">
                                <div class="icon"></div>
                                <div class="content">
                                    <div class="s">{{JSON.parse(item.startPoi).NAME}} {{JSON.parse(item.startPoi).FLOOR_NAME}}层</div>
                                    <div class="e">{{JSON.parse(item.endPoi).NAME}} {{JSON.parse(item.endPoi).FLOOR_NAME}}层</div>
                                </div>
                                <div class="right">
                                    <span class="btn" v-if="!footprintEditState">
                                        <i class="iconfont icon-location-2"></i>
                                        <span>导航</span>
                                    </span>
                                    <span class="remove" @click="deleteD(item)" v-else>
                                        删除
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="save" v-if="editState" @click="save">
                        保存
                    </div>
                    <div class="edit" v-else @click="edit">
                        编辑
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>

    import {getCollectData,deleteCollectData,getHistoryFootData,deleteHistoryFootData} from '@/config/prepare.js';

    export default {
        name: "Footprint",
        data() {
            return {
                visible: this.value,
                tabIndex: this.index,    //切换内容
                editState: 0,   //编辑状态
                collectionEditState: 0,     //
                footprintEditState: 0,

                //收藏夹
                collectionArray: [],

                //历史足迹
                historyArray:[],

                deleteCache:[],
            }
        },
        props: {
            value: {
                default: false
            },
            index: {
                default: '1'
            },
        },
        watch: {
            value(boolean) {
                this.visible = boolean;
                this.tabIndex = this.index;

                //收藏夹
                this.collectionArray = JSON.parse(JSON.stringify(this.$store.state.CollectData));

                //历史足迹
                this.historyArray = JSON.parse(JSON.stringify(this.$store.state.HistoryData))

            },

            tabIndex () {
                this.reset();
            }
        },
        methods: {
            close() {
                this.reset();
                this.$emit('input', this.visible = false);
                this.$emit('on-close', this.visible);
            },

            deleteD(item){

                this.deleteCache.push(item);

                if(this.tabIndex == 1){

                    this.collectionArray.filter(($item,index,self)=>{
                        if($item.id == item.id){
                            this.collectionArray.splice(index,1);
                        }
                    });

                }else{

                    this.historyArray.filter(($item,index,self)=>{
                        if($item.id == item.id){
                            this.historyArray.splice(index,1);
                        }
                    });

                }


            },

            edit () {
                //正在编辑
                this.editState = 1;

                if(this.tabIndex === 1) {
                    this.collectionEditState = 1;
                }

                else {
                    this.footprintEditState = 1;
                }
            },

            save () {

                // this.reset();

                if(this.tabIndex== 1){
                    if(this.deleteCache.length>0){

                        for(let i =0 ;i<this.deleteCache.length;i++){

                            deleteCollectData(this,this.deleteCache[i].id,(res)=>{

                                //请求异步处理导致问题
                                if(i == this.deleteCache.length-1){

                                    getCollectData(this,($res)=>{   //更动数据

                                        if($res.data.code == 0){

                                            this.$store.state.CollectData = $res.data.result;
                                            this.$message.info('保存修改成功');
                                            this.reset();
                                        }
                                    })

                                }

                            })

                        }

                    }else{this.reset();}

                }else{

                    if(this.deleteCache.length>0){

                        for(let i =0 ;i<this.deleteCache.length;i++){

                            deleteHistoryFootData(this,this.deleteCache[i].id,(res)=>{

                                //请求异步处理导致问题
                                if(i == this.deleteCache.length-1){

                                    getHistoryFootData(this,($res)=>{   //更动数据

                                        if($res.data.code == 0){

                                            this.$store.state.HistoryData = $res.data.result;
                                            this.$message.info('保存修改成功');
                                            this.reset();
                                        }
                                    })

                                }

                            })

                        }

                    }else{this.reset();}

                }
            },

            reset () {
                //关闭编辑状态
                this.editState = 0;
                this.collectionEditState = 0;
                this.footprintEditState = 0;

                this.deleteCache = [];
                this.collectionArray = JSON.parse(JSON.stringify(this.$store.state.CollectData));
                this.historyArray = JSON.parse(JSON.stringify(this.$store.state.HistoryData))
            },

            select(item){   //选中处理

                event.stopPropagation();//阻止冒泡

                if(this.tabIndex == 1){ //收藏夹

                    //触发路径规划
                    if(this.$BRT.$options.GuideDrawer){ //设置进入

                        this.$BRT.$selecte.endPoint = item;

                        this.bus.$emit('startAndEnd',{type:2})

                    }else if(this.$BRT.$route.selectType.type == 'foot'){
                        //地图选择进入
                        if(this.$BRT.$route.selectType.pointType == 'start'){
                            this.$BRT.$selecte.startPoint = item;

                        }else{
                            this.$BRT.$selecte.endPoint = item;
                        }

                        this.bus.$emit('startAndEnd',{type:0})

                    }else{  //搜索页进入

                        this.$router.replace('/map');
                        this.$BRT.$route.enterType = 'search';
                        this.$BRT.$selecte.endPoint = item;
                        this.bus.$emit('startAndEnd',{type:2})

                    }

                }


                else{   //历史足迹

                    if(!this.$BRT.$options.GuideDrawer && this.$BRT.$route.selectType.type != 'foot'){  //搜索页进入
                        this.$BRT.$route.enterType = 'search';

                        this.$router.replace('/map');
                    }

                    this.$BRT.$selecte.startPoint = JSON.parse(item.startPoi);
                    this.$BRT.$selecte.endPoint = JSON.parse(item.endPoi);

                    //规划路径
                    this.bus.$emit('startAndEnd',{type:0})
                }

                //关闭
                this.$BRT.$options.Footprint=false;
                this.$BRT.$options.GuideDrawer = false;

                this.$mapStep.type = 'planRoute';

            }

        },
    }
</script>

<style lang="less">

    @import "../../styles/cssBlock.less";

    .brt-footprint-drawer {
        .fixedByCover();
        pointer-events: auto;
        background-color: @maskBgColor;
        z-index: 9000;

        > .brt-footprint {
            display: flex;
            flex-direction: column;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #FFFFFF;
            height: 75%;
            box-shadow: 0 0 @shadowSize @shadowColor;

            > .close {
                @size: @80px;

                width: @size;
                height: @size;
                line-height: @size;
                text-align: center;
                border-radius: 50%;
                background-color: #FFFFFF;
                position: absolute;
                left: 50%;
                margin-left: -(@size / 2);
                top: -(@size * 1.5);

                &:active > .iconfont {
                    color: @fontColorA3;
                }

                &:after {
                    content: '';
                    display: inline-block;
                    height: @size * 0.5;
                    border-right: @4px solid #FFFFFF;
                    position: absolute;
                    top: @size;
                    left: 50%;
                    margin-left: -@2px;
                }

                > .iconfont {
                    color: @fontColorA1;
                    font-size: @40px;
                }
            }

            > .brt-foot-head {
                @height: @85px;

                height: @height;
                display: flex;
                text-align: center;
                border-bottom: 1px solid @fontColorA4;

                > span {
                    flex: 1;
                    display: block;
                    line-height: @height + @1px;
                    color: @fontColorA2;
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -1px;
                        border-bottom: 2px solid var(--themColor);
                        visibility: hidden;
                    }

                    &.active{color: var(--themColor);}

                    &.active:after {
                        visibility: visible;
                    }

                    > i {
                        font-size: @normalFontSize + @4px;
                        vertical-align: middle;
                        position: relative;
                        top: -2px;
                        margin-right: @5px;
                    }
                }
            }

            > .brt-foot-body {
                flex: 1;
                position: relative;

                &[tab-index='2'] {
                    > .brt-foot-scroll {
                        &:nth-child(1) {
                            transform: translateX(-100%);
                        }
                        &:nth-child(2) {
                            transform: translateX(0);
                        }
                    }
                }

                > .brt-foot-scroll {
                    .absoluteByCover();
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    transition: transform .2s linear;

                    &:nth-child(2) {
                        transform: translateX(100%);
                    }
                }

                .collection-ul {
                    padding: 0 @spacingNumber;

                    > li {
                        display: flex;
                        align-items: center;
                        padding: @spacingNumber 0;
                        border-bottom: 1px solid @borderColorA2;
                        color: @fontColorA1;

                        &:active {
                            background-color: @activeBgColorA1;
                        }

                        > .icon {
                            width: @40px;
                            text-align: center;
                            font-size: 0;

                            > .img {
                                @size: @normalFontSize + @4px;
                                width: @size;
                                height: @size;
                            }

                            > .iconfont {
                                font-size: @normalFontSize + @10px;
                            }
                        }

                        > .content {
                            flex: 1;
                            min-width: 1px;
                            padding: 0 @20px;

                            .t2 {
                                font-size: @23px;
                                margin-top: @10px;
                                color: @fontColorA3;

                                > i {
                                    display: inline-block;
                                    height: @15px;
                                    border-right: 1px solid @fontColorA4;
                                    margin: 0 @6px;
                                }
                            }
                        }

                        > .right {

                            > .btn {
                                display: inline-block;
                                text-align: center;

                                > .iconfont {
                                    display: inline-block;
                                    width: @45px;
                                    height: @45px;
                                    line-height: @43px;
                                    text-align: center;
                                    border-radius: 50%;
                                    background-color: @fontColorA2;
                                    color: #FFFFFF;
                                    font-size: @32px;
                                }

                                > span {
                                    display: block;
                                    font-size: @24px;
                                    color: @fontColorA2;
                                    margin-top: @5px;
                                }
                            }
                        }
                    }
                }

                .footprint-ul {
                    padding: 0 @spacingNumber;

                    > li {
                        display: flex;
                        align-items: center;
                        padding: @spacingNumber 0;
                        border-bottom: 1px solid @borderColorA2;
                        color: @fontColorA1;

                        &:active {
                            background-color: @activeBgColorA1;
                        }

                        > .content {
                            flex: 1;
                            min-width: 1px;

                            > div {
                                &:before {
                                    display: inline-block;
                                    content: '';
                                    width: @18px;
                                    height: @18px;
                                    border-radius: 50%;
                                    background-color: @successColor;
                                    vertical-align: middle;
                                    margin-right: @20px;
                                    position: relative;
                                    top: -1px;
                                }

                                &.e {
                                    margin-top: @25px;

                                    &:before {
                                        background-color: @warningColor;
                                    }
                                }
                            }

                        }

                        > .right {

                            > .btn {
                                @size   : @62px;

                                display: inline-block;
                                height: @size;
                                line-height: @size;
                                border-radius: @size;
                                padding: 0 @20px;
                                background-color: var(--themColor);
                                color: @themeReverseColor;
                                font-size: @28px;

                                > .iconfont {
                                    font-size: @34px;
                                    vertical-align: middle;
                                    position: relative;
                                    top: -2px;
                                    margin-right: @5px;
                                }
                            }
                        }
                    }
                }

                > .edit,
                > .save {
                    position: absolute;
                    bottom: @spacingNumber;
                    right: @spacingNumber;
                    height: @60px;
                    line-height: @60px;
                    border-radius: @50px;
                    color: #FFFFFF;
                    background-color: @fontColorA1;
                    padding: 0 @spacingNumber;
                    font-size: @28px;

                    &:active {
                        background-color: @fontColorA2;
                    }
                }

                > .save {
                    background-color: var(--themColor);

                    &:active {
                        background-color: var(--themShadow);
                    }
                }

                .remove {
                    display: inline-block;
                    font-size: @28px;
                    color: @warningColor;
                    padding: @10px;
                }

            }
        }
    }
</style>
